interface OtherFieldProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}
export function OtherField({
  value,
  placeholder,
  onChange
}: OtherFieldProps) {
  return <input autoFocus type="text" value={value} placeholder={placeholder} aria-label="Descreva sua resposta" onChange={e => onChange(e.target.value)} onClick={e => e.stopPropagation()} className="w-full border-b border-cream-100/40 bg-transparent pb-2 font-display text-lg text-cream-50 outline-none transition-colors duration-200 ease-soft placeholder:text-cream-100/40 focus:border-gold-400" data-id="element-50" data-mp="28gentokr98gc" />;
}